import { v4 as uuid } from 'uuid';

export class UniFunc {

  static END_POINT = "uni_func";

  //#region  --- Columns ---
  serno = 0;
  guid;//= uuid();

  /** 是否為特殊作業問卷 */
  is_spwk = 0;

  func_code = "";
  func_title = "";
  func_short = "";
  //#endregion

  constructor() {
    this.guid = uuid();
  }

  getCodeTitle() {
    return `[${this.func_code}] ${this.func_title}`;
  }

}